import { Data } from './types'

export const getProfileName = (
  { firstName, lastName }: Data,
  defaultName?: string,
): string => (firstName && lastName ? [firstName, lastName].join(' ') : defaultName || '')
